import { Component, OnInit, OnDestroy } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { SetShowAlert } from "@edp-store/actions/edpe.actions";
import { takeUntil, filter } from "rxjs/operators";
import { Subject } from "rxjs";
import { getUser } from "@edp-store/selectors/user.selectors";
import { EdpUser } from "@edp-models/user.model";
import { Router } from "@angular/router";
import { environment } from "@edp-environments/environment";
import { SetHeaderAlert } from "@edp-store/actions/layout.actions";

@Component({
  selector: "edp-alert",
  templateUrl: "./edp-alert.component.html",
  styleUrls: ["./edp-alert.component.scss"]
})
export class EdpAlertComponent implements OnInit, OnDestroy {
    public user: EdpUser;
    private unsubscribe = new Subject();
    public isApp: boolean;

    constructor(
        private store: Store,
        private router: Router) {
    }

    ngOnInit(): void {
        this.isApp = environment.isApp;
    }

    public close() {
        localStorage.setItem("user-tob-bar", "true");
        this.store.dispatch(new SetHeaderAlert(false));
    }

    public ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }

}
